import React from 'react';

class SwitchInput extends React.Component{
    constructor(props) {
      super(props);

      this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e) {
      e.preventDefault();
      this.refs.switch.click();
    }

    render(){
      const { 
        input_type, 
        input_name, 
        input_label, 
        input_value, 
        input_placeholder, 
        input_onChange,
        input_invalid_feedback,
        input_is_required,
        input_parent,
        input_rows
      } = this.props;

      return(
        
        <div className="form-group">
            <div className="form-check form-check-inline">
              <input
                id="cmn-toggle"
                className="cmn-toggle cmn-toggle-round"
                name={input_name}
                type="checkbox"
                ref="switch"
                checked={input_value}
                value={input_value}
                onChange={input_onChange}
                data-parent={ input_parent } />
                <label className="form-control-label" onClick={this.handleClick}>&nbsp;</label>
            </div>
        </div>
      );
    }
} 

export {SwitchInput};



// WEBPACK FOOTER //
// ./src/components/SwitchInput.js